<script setup>

import { ref, computed } from "vue";
import ListaDePedidosCartao from "./ListaDePedidos/ListaDePedidosCartao.vue";
import RevisarPedidoDeCompraModal from "./RevisarPedidoDeCompra/RevisarPedidoDeCompraModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";
import UtilArray from "../../utils/UtilArray.mjs";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//======================== Revisando Pedido ========================//
//==================================================================//

const revisandoPedido = ref(false);

//==================================================================//
//======================== Pedido de Compra ========================//
//==================================================================//

const pedidosDeCompra = ref([]);
const pedidoDeCompra = ref({});

//==================================================================//
//========================== Fornecedores ==========================//
//==================================================================//

const fornecedores = ref([]);

//==================================================================//
//================ Parcelas Condicoes de Pagamento =================//
//==================================================================//

const parcelasCondicoesDePagamento = ref([]);

//==================================================================//
//======================== Itens Unidades ==========================//
//==================================================================//

const itensUnidades = ref([]);

//==================================================================//
//================= Cotacoes de Pedido de Compra ===================//
//==================================================================//

const cotacoesDePedidoDeCompra = ref([]);

//==================================================================//
//============= Cotações de Pedidos de Compra Computed =============//
//==================================================================//

const cotacoesDePedidosDeCompraComputed = computed(()=>{

    return cotacoesDePedidoDeCompra.value.reduce((acc,cotacaoDePedidoDeCompra)=>{

        let itensNaoAdicionados = cotacaoDePedidoDeCompra.itens.filter(({adicionado}) => adicionado == false);

        if(UtilArray.isNotEmpty(itensNaoAdicionados)){

            acc.push({
                ...cotacaoDePedidoDeCompra,
                itens: itensNaoAdicionados
            });

        }

        return acc;

    },[]);

});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//==================== Altera Fornecedores ========================//
//==================================================================//

const alteraFornecedores = (update=[])=>{

    fornecedores.value = update;

};

//==================================================================//
//=========== Altera Parcelas Condicoes de Pagamento ===============//
//==================================================================//

const alteraParcelasCondicoesDePagamento = (update=[])=>{

    parcelasCondicoesDePagamento.value = update;

};

//==================================================================//
//=================== Altera Itens Unidades ========================//
//==================================================================//

const alteraItensUnidades = (update=[])=>{

    itensUnidades.value = update;

};

//==================================================================//
//============== Altera Cotacoes de Pedido de Compra ===============//
//==================================================================//

const alteraCotacoesDePedidoDeCompra = (update=[])=>{

    cotacoesDePedidoDeCompra.value = update;

};


//==================================================================//
//=========== Altera Cotacao de Pedido de Compra Item ==============//
//==================================================================//

const alteraCotacaoDePedidoDeCompraItem = (update={})=>{

    let cotacaoID = update.cotacaoItem.cotacaoDePedidoDeCompra;
    let cotacaoItemID = update.cotacaoItem.id;
    let cotacaoItemPatch = update.cotacaoItemPatch;
        
    const cotacaoDePedidoDeCompra = cotacoesDePedidoDeCompra.value.find(({id}) => id == cotacaoID);
    if(!cotacaoDePedidoDeCompra){
        return;
    }

    const cotacaoDePedidoDeCompraItem = cotacaoDePedidoDeCompra.itens.find(({id}) => id == cotacaoItemID);
    if(!cotacaoDePedidoDeCompraItem){
        return;
    }

    Object.assign(cotacaoDePedidoDeCompraItem, cotacaoItemPatch);

};

//==================================================================//
//================== Altera Pedidos de Compra ======================//
//==================================================================//

const alteraPedidosDeCompra = (update=[])=>{

    pedidosDeCompra.value = update;

};

//==================================================================//
//================= Altera Pedido de Compra ========================//
//==================================================================//

const alteraPedidoDeCompra = (update={})=>{

    pedidoDeCompra.value = update;

};

//==================================================================//
//=================== Altera Revisando Pedido ======================//
//==================================================================//

const alteraRevisandoPedido = (update={})=>{

    revisandoPedido.value = update.revisandoPedido;
    alteraPedidoDeCompra(update.pedidoDeCompra);

};

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Revisão de Pedidos de Compra
        </h2>

        <ListaDePedidosCartao
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidosDeCompra="pedidosDeCompra"
            :pedidoDeCompra="pedidoDeCompra"
            :fornecedores="fornecedores"
            :parcelasCondicoesDePagamento="parcelasCondicoesDePagamento"
            :itensUnidades="itensUnidades"
            :revisandoPedido="revisandoPedido"
            :controlesDesativados="controlesDesativados"
            @update:pedidosDeCompra="alteraPedidosDeCompra"
            @update:pedidoDeCompra="alteraPedidoDeCompra"
            @update:revisandoPedido="alteraRevisandoPedido"
            @update:fornecedores="alteraFornecedores"
            @update:parcelasCondicoesDePagamento="alteraParcelasCondicoesDePagamento"
            @update:itensUnidades="alteraItensUnidades"
            @update:cotacoesDePedidoDeCompra="alteraCotacoesDePedidoDeCompra"
            @update:controlesDesativados="alteraControlesDesativados"
        ></ListaDePedidosCartao>
       
        <RevisarPedidoDeCompraModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidoDeCompra="pedidoDeCompra"
            :fornecedores="fornecedores"
            :parcelasCondicoesDePagamento="parcelasCondicoesDePagamento"
            :itensUnidades="itensUnidades"
            :cotacoesDePedidoDeCompra="cotacoesDePedidosDeCompraComputed"
            :revisandoPedido="revisandoPedido"
            :controlesDesativados="controlesDesativados"
            @update:pedidoDeCompra="alteraPedidoDeCompra"
            @update:revisandoPedido="alteraRevisandoPedido"
            @update:cacheFornecedores="alteraFornecedores"
            @update:cotacaoDePedidoDeCompraItem="alteraCotacaoDePedidoDeCompraItem"
            @update:controlesDesativados="alteraControlesDesativados"
        ></RevisarPedidoDeCompraModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>